import { render, staticRenderFns } from "./like-card.vue?vue&type=template&id=d7cee9a4&scoped=true&"
import script from "./like-card.vue?vue&type=script&lang=js&"
export * from "./like-card.vue?vue&type=script&lang=js&"
import style0 from "./like-card.vue?vue&type=style&index=0&id=d7cee9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cee9a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
